var levelOfAWSUsage = {
	"Level of AWS usage": "Level of AWS usage",
	"Do not use AWS today": "Do not use AWS today",
	"Evaluating/experimenting with AWS": "Evaluating/experimenting with AWS",
	"Run dev/test workloads on AWS": "Run dev/test workloads on AWS",
	"Run a production workload on AWS": "Run a production workload on AWS",
	"Run multiple production workloads on AWS": "Run multiple production workloads on AWS"
};

export { levelOfAWSUsage as default };
